export default __webpack_public_path__ + "static/media/Collab4.fa69f346.png";